/**
 * 分润表请求接口
 * @author 王振宇
 * @since 2022-08-01
 */
export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request,
    serviceForMock = _ref.serviceForMock,
    requestForMock = _ref.requestForMock,
    mock = _ref.mock,
    faker = _ref.faker,
    tools = _ref.tools;
  return {
    GET_PROFITDISTRIBUTION_PAGE_LIST: function GET_PROFITDISTRIBUTION_PAGE_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/profitDistribution/getPageList',
        method: 'post',
        data: data
      });
    },
    GET_PROFITDISTRIBUTION_LIST: function GET_PROFITDISTRIBUTION_LIST() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/profitDistribution/getList',
        method: 'get',
        params: data
      });
    },
    GET_PROFITDISTRIBUTION_INFO: function GET_PROFITDISTRIBUTION_INFO() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/profitDistribution/info',
        method: 'get',
        params: data
      });
    },
    SAVE_PROFITDISTRIBUTION: function SAVE_PROFITDISTRIBUTION() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/profitDistribution/save',
        method: 'post',
        data: data
      });
    },
    UPDATE_PROFITDISTRIBUTION: function UPDATE_PROFITDISTRIBUTION() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/profitDistribution/update',
        method: 'put',
        data: data
      });
    },
    DELETE_PROFITDISTRIBUTION: function DELETE_PROFITDISTRIBUTION() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/profitDistribution/delete',
        method: 'delete',
        data: data
      });
    },
    DELETE_BATCH_PROFITDISTRIBUTION: function DELETE_BATCH_PROFITDISTRIBUTION() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      data.operatorUserId = tools.getUserId();
      data.loginType = tools.getLoginType();
      return request({
        url: '/admin/v1/profitDistribution/deleteBatch',
        method: 'delete',
        data: data
      });
    }
  };
});